(() => {
  if (window.__LDJ_HEADER_LOADED__) return;
  window.__LDJ_HEADER_LOADED__ = true;

  const initHeader = (header) => {
    if (!header || header.dataset.initialized === 'true') return;

    header.dataset.initialized = 'true';

    const isHomepage = header.dataset.homepage === 'true';

    const mobileToggle = header.querySelector('[data-mobile-menu-toggle]');
    const mobileMenu = header.querySelector('[data-mobile-menu]');

    const desktopTriggers = [
      ...header.querySelectorAll('[data-desktop-dropdown-trigger]')
    ];

    const mobileDropdownTriggers = [
      ...header.querySelectorAll('[data-mobile-dropdown-trigger]')
    ];

    const dropdowns = [
      ...header.querySelectorAll('[data-dropdown-panel]')
    ];

    let closeTimer = null;

    const anyDropdownOpen = () =>
      dropdowns.some((dropdown) => dropdown.classList.contains('is-open'));

    const updateHeaderAppearance = () => {
      const menuOpen =
        mobileMenu?.classList.contains('is-open') ||
        anyDropdownOpen();

      const transparent =
        isHomepage &&
        window.scrollY <= 10 &&
        !menuOpen;

      header.classList.toggle('ldj-header--transparent', transparent);
      header.classList.toggle('ldj-header--solid', !transparent);
    };

    const closeDropdowns = () => {
      dropdowns.forEach((dropdown) => {
        dropdown.classList.remove('is-open');
      });

      desktopTriggers.forEach((trigger) => {
        trigger.setAttribute('aria-expanded', 'false');
      });

      updateHeaderAppearance();
    };

    const openDropdown = (key) => {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
      }

      dropdowns.forEach((dropdown) => {
        const shouldOpen = dropdown.dataset.dropdownKey === key;
        dropdown.classList.toggle('is-open', shouldOpen);
      });

      desktopTriggers.forEach((trigger) => {
        trigger.setAttribute(
          'aria-expanded',
          trigger.dataset.dropdownKey === key ? 'true' : 'false'
        );
      });

      updateHeaderAppearance();
    };

    const scheduleDropdownClose = () => {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
      }

      closeTimer = window.setTimeout(() => {
        closeDropdowns();
      }, 120);
    };

    const cancelDropdownClose = () => {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
      }
    };

    const setMobileMenu = (open) => {
      if (!mobileMenu || !mobileToggle) return;

      mobileMenu.classList.toggle('is-open', open);
      mobileMenu.setAttribute('aria-hidden', open ? 'false' : 'true');

      mobileToggle.classList.toggle('is-open', open);
      mobileToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileToggle.setAttribute(
        'aria-label',
        open ? 'Close menu' : 'Open menu'
      );

      document.documentElement.classList.toggle(
        'ldj-mobile-menu-open',
        open
      );

      updateHeaderAppearance();
    };

    mobileToggle?.addEventListener('click', () => {
      const opening = !mobileMenu.classList.contains('is-open');

      closeDropdowns();
      setMobileMenu(opening);
    });

    desktopTriggers.forEach((trigger) => {
      trigger.addEventListener('mouseenter', () => {
        if (window.innerWidth < 768) return;

        cancelDropdownClose();
        openDropdown(trigger.dataset.dropdownKey);
      });

      trigger.addEventListener('mouseleave', () => {
        if (window.innerWidth < 768) return;

        scheduleDropdownClose();
      });

      trigger.addEventListener('focus', () => {
        if (window.innerWidth < 768) return;

        openDropdown(trigger.dataset.dropdownKey);
      });
    });

    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('mouseenter', () => {
        if (window.innerWidth < 768) return;

        cancelDropdownClose();
      });

      dropdown.addEventListener('mouseleave', () => {
        if (window.innerWidth < 768) return;

        scheduleDropdownClose();
      });
    });

    mobileDropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        setMobileMenu(false);
        openDropdown(trigger.dataset.dropdownKey);
      });
    });

    window.addEventListener(
      'scroll',
      updateHeaderAppearance,
      { passive: true }
    );

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 768) {
        setMobileMenu(false);
      }

      updateHeaderAppearance();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      setMobileMenu(false);
      closeDropdowns();
    });

    document.addEventListener('click', (event) => {
      if (header.contains(event.target)) return;

      closeDropdowns();
    });

    updateHeaderAppearance();
  };

  const initAllHeaders = (root = document) => {
    root.querySelectorAll('[data-ldj-header]').forEach(initHeader);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllHeaders();
    });
  } else {
    initAllHeaders();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllHeaders(event.target);
  });
})();
